export enum EColorsStatus  {
  "Prazo Excedido" = "negative",
  "Plano de ação ok" = "positive",
  "Normalizado/Não Reconhecido" = "warning",
  "Não Reconhecido" = "warning"
}

export interface EncaminhadoItem {
  id: number | string;
  email: string;
  nome: string;
  idLoja: number;
  idUsuario: number;
}